// @flow
import * as PublicAccountPagesConstants from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

type StateType = {
  formElements: {
    username: string,
    password: string   
  },
  status: {
    isPosting: boolean,
    isLoginSuccessful: boolean,
    hasError: boolean
  },
  authInfos: {
    token: string
  }
}

type ActionType = {
  type: string,
  payload: Object
};

const initialState = {
  formElements: {
    username: "",
    password: ""  
  },
  status: {
    isPosting: false,
    isLoginSuccessful: false,
    hasError: false
  },
  authInfos: {
    token: ""
  }
};

export default function login(state: StateType = initialState, action: ActionType) {
  switch (action.type) {
    case PublicAccountPagesConstants.LOGIN_FORM_ELEMENT_VALUE_CHANGE:
      return loginFormElementValueChange(state, action);
    case PublicAccountPagesConstants.LOGIN_FORM_SUBMIT_REQUEST:
      return loginFormSubmitRequest(state);
    case PublicAccountPagesConstants.LOGIN_FORM_SUBMIT_SUCCESS:
      return loginFormSubmitSuccess(state, action);
    case PublicAccountPagesConstants.LOGIN_FORM_SUBMIT_FAILURE:
      return loginFormSubmitFailure(state);
    case PublicAccountPagesConstants.LOGIN_FORM_ERROR_RELEASE:
      return loginFormErrorRelease(state);
    // Cookie Worker Reducers
    default:
      return state;
  }
}

function loginFormElementValueChange(state, action) {
  const { formElement, value } = action.payload;
  return {
    ...state,
    formElements: {
      ...state.formElements,
      [formElement]: value
    }
  }
}

function loginFormSubmitRequest(state) {
  return {
    ...state,
    status: {
      ...state.status,
      isPosting: true,
      isLoginSuccessful: false,
      hasError: false
    }
  }
}

function loginFormSubmitSuccess(state, action) {
  const { token } = action.payload;
  return {
    ...state,
    status: {
      ...state.status,
      isPosting: false,
      isLoginSuccessful: true,
      hasError: false
    },
    authInfos: {
      token
    }
  }
}

function loginFormSubmitFailure(state) {
  return {
    ...state,
    status: {
      ...state.status,
      isPosting: false,
      isLoginSuccessful: false,
      hasError: true
    }
  }
}

function loginFormErrorRelease(state) {
  return {
    ...state,
    status: {
      ...state.status,
      isPosting: false,
      isLoginSuccessful: false,
      hasError: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/PublicAccountPages/login.js